import { useMutation } from "@tanstack/react-query";
import { Post } from "../../../utils/apiService";
import {
  ExportVisitRequestsReportForExcelPDFBody,
  ExportAuditLogsReportForExcelPDFBody,
  ExportExternalUsersReportForExcelPDFBody,
  ExportFRAccessLogsReportForExcelPDFBody,
  ExportFRErrorsReportForExcelPDFBody,
  ExportLoginUsersReportForExcelPDFBody,
  ExportRatingsReportForExcelPDFBody,
  ExportVisitorsReportForExcelPDFBody,
  ExportOverStayedVisitorsReportForExcelPDFBody,
  ExportBlacklistingReportForExcelPDFBody,
} from "../interface";

const exportVisitRequestsReportForExcelAction = async (
  body: ExportVisitRequestsReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/Excel/GetAllVisitRequest",
    body,
    isReturnBlob: true,
  });
};

export const useExportVisitRequestsReportForExcel = () => {
  return useMutation({
    mutationFn: async (body: ExportVisitRequestsReportForExcelPDFBody) =>
      exportVisitRequestsReportForExcelAction(body),
  });
};

const exportVisitRequestsReportForPDFAction = async (
  body: ExportVisitRequestsReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/PDF/GetAllVisitRequest",
    body,
    isReturnBlob: true,
  });
};

export const useExportVisitRequestsReportForPDF = () => {
  return useMutation({
    mutationFn: async (body: ExportVisitRequestsReportForExcelPDFBody) =>
      exportVisitRequestsReportForPDFAction(body),
  });
};

const exportVisitorsReportForExcelAction = async (
  body: ExportVisitorsReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/Excel/GetCheckedInOutVisitors",
    body,
    isReturnBlob: true,
  });
};

export const useExportVisitorsReportForExcel = () => {
  return useMutation({
    mutationFn: async (body: ExportVisitorsReportForExcelPDFBody) =>
      exportVisitorsReportForExcelAction(body),
  });
};

const exportVisitorsReportForPDFAction = async (
  body: ExportVisitorsReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/PDF/GetCheckedInOutVisitors",
    body,
    isReturnBlob: true,
  });
};

export const useExportVisitorsReportForPDF = () => {
  return useMutation({
    mutationFn: async (body: ExportVisitorsReportForExcelPDFBody) =>
      exportVisitorsReportForPDFAction(body),
  });
};

const exportFRAccessLogsReportForExcelAction = async (
  body: ExportFRAccessLogsReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/Excel/GetFRAccessLogs",
    body,
    isReturnBlob: true,
  });
};

export const useExportFRAccessLogsReportForExcel = () => {
  return useMutation({
    mutationFn: async (body: ExportFRAccessLogsReportForExcelPDFBody) =>
      exportFRAccessLogsReportForExcelAction(body),
  });
};

const exportFRAccessLogsReportForPDFAction = async (
  body: ExportFRAccessLogsReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/PDF/GetFRAccessLogs",
    body,
    isReturnBlob: true,
  });
};

export const useExportFRAccessLogsReportForPDF = () => {
  return useMutation({
    mutationFn: async (body: ExportFRAccessLogsReportForExcelPDFBody) =>
      exportFRAccessLogsReportForPDFAction(body),
  });
};

const exportExternalUsersReportForExcelAction = async (
  body: ExportExternalUsersReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/Excel/GetAllExternalUsers",
    body,
    isReturnBlob: true,
  });
};

export const useExportExternalUsersReportForExcel = () => {
  return useMutation({
    mutationFn: async (body: ExportExternalUsersReportForExcelPDFBody) =>
      exportExternalUsersReportForExcelAction(body),
  });
};

const exportExternalUsersReportForPDFAction = async (
  body: ExportExternalUsersReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/PDF/GetAllExternalUsers",
    body,
    isReturnBlob: true,
  });
};

export const useExportExternalUsersReportForPDF = () => {
  return useMutation({
    mutationFn: async (body: ExportExternalUsersReportForExcelPDFBody) =>
      exportExternalUsersReportForPDFAction(body),
  });
};

const exportLoginUsersReportForExcelAction = async (
  body: ExportLoginUsersReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/Excel/GetUsersLogin",
    body,
    isReturnBlob: true,
  });
};

export const useExportLoginUsersReportForExcel = () => {
  return useMutation({
    mutationFn: async (body: ExportLoginUsersReportForExcelPDFBody) =>
      exportLoginUsersReportForExcelAction(body),
  });
};

const exportLoginUsersReportForPDFAction = async (
  body: ExportLoginUsersReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/PDF/GetUsersLogin",
    body,
    isReturnBlob: true,
  });
};

export const useExportLoginUsersReportForPDF = () => {
  return useMutation({
    mutationFn: async (body: ExportLoginUsersReportForExcelPDFBody) =>
      exportLoginUsersReportForPDFAction(body),
  });
};

const exportAuditLogsReportForExcelAction = async (
  body: ExportAuditLogsReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/Excel/GetAllAuditLogs",
    body,
    isReturnBlob: true,
  });
};

export const useExportAuditLogsReportForExcel = () => {
  return useMutation({
    mutationFn: async (body: ExportAuditLogsReportForExcelPDFBody) =>
      exportAuditLogsReportForExcelAction(body),
  });
};

const exportAuditLogsReportForPDFAction = async (
  body: ExportAuditLogsReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/PDF/GetAllAuditLogs",
    body,
    isReturnBlob: true,
  });
};

export const useExportAuditLogsReportForPDF = () => {
  return useMutation({
    mutationFn: async (body: ExportAuditLogsReportForExcelPDFBody) =>
      exportAuditLogsReportForPDFAction(body),
  });
};

const exportOverStayedVisitorsReportForExcelAction = async (
  body: ExportOverStayedVisitorsReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/Excel/GetOverStayedVisitors",
    body,
    isReturnBlob: true,
  });
};

export const useExportOverStayedVisitorsReportForExcel = () => {
  return useMutation({
    mutationFn: async (body: ExportOverStayedVisitorsReportForExcelPDFBody) =>
      exportOverStayedVisitorsReportForExcelAction(body),
  });
};

const exportOverStayedVisitorsReportForPDFAction = async (
  body: ExportOverStayedVisitorsReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/PDF/GetOverStayedVisitors",
    body,
    isReturnBlob: true,
  });
};

export const useExportOverStayedVisitorsReportForPDF = () => {
  return useMutation({
    mutationFn: async (body: ExportOverStayedVisitorsReportForExcelPDFBody) =>
      exportOverStayedVisitorsReportForPDFAction(body),
  });
};

const exportFRErrorsReportForExcelAction = async (
  body: ExportFRErrorsReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/Excel/GetFRErrorsReport",
    body,
    isReturnBlob: true,
  });
};

export const useExportFRErrorsReportForExcel = () => {
  return useMutation({
    mutationFn: async (body: ExportFRErrorsReportForExcelPDFBody) =>
      exportFRErrorsReportForExcelAction(body),
  });
};

const exportFRErrorsReportForPDFAction = async (
  body: ExportFRErrorsReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/PDF/GetFRErrorsReport",
    body,
    isReturnBlob: true,
  });
};

export const useExportFRErrorsReportForPDF = () => {
  return useMutation({
    mutationFn: async (body: ExportFRErrorsReportForExcelPDFBody) =>
      exportFRErrorsReportForPDFAction(body),
  });
};

const exportRatingsReportForExcelAction = async (
  body: ExportRatingsReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/Excel/GetRatingsReport",
    body,
    isReturnBlob: true,
  });
};

export const useExportRatingsReportForExcel = () => {
  return useMutation({
    mutationFn: async (body: ExportRatingsReportForExcelPDFBody) =>
      exportRatingsReportForExcelAction(body),
  });
};

const exportRatingsReportForPDFAction = async (
  body: ExportRatingsReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/PDF/GetRatingsReport",
    body,
    isReturnBlob: true,
  });
};

export const useExportRatingsReportForPDF = () => {
  return useMutation({
    mutationFn: async (body: ExportRatingsReportForExcelPDFBody) =>
      exportRatingsReportForPDFAction(body),
  });
};

const exportBlacklistingReportForPDFAction = async (
  body: ExportBlacklistingReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/PDF/GetBlacklistingReport",
    body,
    isReturnBlob: true,
  });
};

export const useExportBlacklistingReportForPDF = () => {
  return useMutation({
    mutationFn: async (body: ExportBlacklistingReportForExcelPDFBody) =>
      exportBlacklistingReportForPDFAction(body),
  });
};

const exportBlacklistingReportForExcelAction = async (
  body: ExportBlacklistingReportForExcelPDFBody
) => {
  return Post({
    url: "/api/Export/Excel/GetBlacklistingReport",
    body,
    isReturnBlob: true,
  });
};

export const useExportBlacklistingReportForExcel = () => {
  return useMutation({
    mutationFn: async (body: ExportBlacklistingReportForExcelPDFBody) =>
      exportBlacklistingReportForExcelAction(body),
  });
};
